@if (context.visit) {
  <div class="fieldset" [ngClass]="{'disabled' : isReadOnlyForUser}">
    <router-outlet></router-outlet>
  </div>
  @if (eventId) {
    <app-ribbon></app-ribbon>
  }
}
